import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import firebase from './firebase';
import 'firebase/auth';

const vuexPersist = new VuexPersist({
  key: 'it-support',
  storage: localStorage,
  reducer: (state) => ({ userState: { token: state.userState.token } })
});

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    user: firebase.auth().currentUser,
    userState: {
      isLoggingIn: true,
      token: ''
    },
    snackbar: {
      visible: false,
      text: null,
      timeout: 6000,
      multiline: false,
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    initUser(state, payload) {
      state.userState.isLoggingIn = false;
      state.user = payload;
    },
    setUserToken(state, payload) {
      state.userState.token = payload.token;
    },
    showSnackbar(state, payload) {
      state.snackbar.text = payload.text;
      state.snackbar.multiline = (payload.text.length > 50) ? true : false;

      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline;
      }

      if (payload.timeout) {
        state.snackbar.timeout = payload.timeout;
      }

      state.snackbar.visible = true;
    },
    closeSnackbar(state) {
      state.snackbar.visible = false;
      state.snackbar.multiline = false;
      state.snackbar.timeout = 6000;
      state.snackbar.text = null;
    },
  },
  actions: {
    signIn({ commit }, payload) {
      return new Promise((resolve, reject) => {
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => {
            return firebase.auth().signInWithEmailAndPassword(payload.email, payload.password);
          })
          .then(res => {
            // commit("setUserToken", { token: res.credential })
            // res.user.getIdToken().then(token => {
            //   commit("setUserToken", { token: token })
            // })
            commit("setUser", res.user);
            return resolve(res.user.uid);
          })
          .catch(reason => {
            return reject(reason);
          });
      });
    },
    async currentUser(){
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      return firebase.auth().currentUser;
    }
  }
});

firebase.auth().onAuthStateChanged((user) => {
  store.commit('initUser', user);
});

export default store;